import { SurfaceBlockVoidComponent } from './surface-block-void.js';
import { surfaceViewingEffects } from './viewing';

export function effects() {
  customElements.define('affine-surface-void', SurfaceBlockVoidComponent);
  surfaceViewingEffects();
}
